import { createContext } from 'react';

import { PopupContextValue } from './Popup.types';

export const PopupContext = createContext<PopupContextValue>({
    visible: false,
});
